var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "poll-text" }, [
      _vm._v(
        _vm._s(
          _vm._(
            "Якщо у Вас є діти віком до 12 місяців - дайте відповідь на декілька простих запитань і отримайте приємний сюрприз!"
          )
        )
      )
    ]),
    _c("img", {
      staticClass: "poll-gift-decor",
      attrs: { src: "/static/images/gift.svg" }
    }),
    _c(
      "button",
      {
        staticClass: "poll-btn",
        attrs: { href: "" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.next($event)
          }
        }
      },
      [_vm._v(_vm._s(_vm._("Почати")))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3164aacc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3164aacc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/poll/steps/init.vue
// module id = 213
// module chunks = 4